import Loader from "./Loader";
import { StyledLoaderWrapper } from "./LoaderWrapper.styled";
import { StyledLoaderWrapperFullWidth } from "./LoaderWrapperFullWidth.styled";

export default Loader;
export { StyledLoaderWrapper, StyledLoaderWrapperFullWidth };
